import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PermissionGuard implements CanActivate {

	constructor(private authenticationService: AuthenticationService) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (next && next.data && next.data.permissions && next.data.permissions.length) {
			return this.authenticationService.hasPermission(next.data.permissions);
		} else {
			return of(true);
		}
	}
}
